import { DectorService } from './../Services/dector.service';
import { Component, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { browserRefresh } from '../app.component';
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { SettingService } from "../Services/setting.service";
import { Location } from "@angular/common";
// declare var InApp:any;


@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  standalone:false,
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  password
  passwordForm: FormGroup;
  mobileminlength: any;
  mobilemaxlength: any;
  idnumber: string;
  userEmail:string;
  userMobile:string;

  constructor(private auth: AuthService, private location: Location, private setting: SettingService, private commonService: CommonService, public errorKey: ErrorMessageKeyService, private translate: TranslateService, private dectorService: DectorService, private fb: FormBuilder, private _router: Router, private cookieService: CookieService
  ) {

    this.passwordForm = this.fb.group({
      passworform: [
        "",
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(15),
        ],
      ]
    });

  }

  async ngOnInit(): Promise<void> {
    let R = await this.cookieService.get("xVal", true);
    if (R) {
      this.idnumber = R;
    }
  }

  getMessage(key, control) {

    let error = "";
    this.translate.get([key]).subscribe((data) => {
      if (control == "officeno") {
        if (key == "MobileMin") {
          error = data[key];
          error = error.replace("{minLength}", this.mobileminlength.toString());
        } else if (key == "MobileMax") {
          error = data[key];
          error = error.replace("{maxLength}", this.mobilemaxlength.toString());
        } else {
          error = data[key];
        }
      } else {
        error = data[key];
      }
    });
    return error;
  }

  isValid(): boolean {
    return this.passwordForm.invalid;
  }

  forgotPass() {
    this._router.navigateByUrl("/CreatePassword");
  }

async passwordflow() {

    this.commonService.presentLoading();
    let body = {
      UniqueId: this.commonService.Guid(),
      IdNumber: this.idnumber,
      Password: this.password,

    }

    this.setting.VerifyPassword_TLAPI(body).then(async (res: any) => {
      if (res?.response?.code == 1) {
    await this.sendEmailMobileOtp();
      }
      else {
        this.commonService.hideLoading();
        this.commonService.ParseErrorAlert('', 'OK', this._router, res);
      }
    })
  }
  back() {
    this.location.back();
  }
  sendEmailMobileOtp() {

    let body = {

      IdNumber: this.idnumber,
      userEmailId: "",
      userMobileNo: "",
      sendEmailOTP: true,
      sendMobileOTP: true,
      isLoggedIn: true

    }

    this.auth.GenerateOTP(body).then((res: any) => {
      if (res?.response?.code == 1) {
        this.commonService.hideLoading();
        this.userEmail=res?.response?.content?.userEmailId
        this.userMobile=res?.response?.content?.userMobileNo
        this.cookieService.set("xerV2r",this.userEmail,true);
        this.cookieService.set("fg2tr",this.userMobile,true);

      this._router.navigateByUrl("/VerifyEmailMobile");
      }
      else {
        this.commonService.hideLoading();
        this.commonService.ParseErrorAlert('', 'OK', this._router, res);
      }
    })
  }

}




